import { Theme } from '@emotion/react';
import { SxProps } from '@mui/system';

const styles = {
  container: {
    position: 'relative',
  },
  cards: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  cardColor: (backgroundColor: string) =>
    ({
      backgroundColor,
    }),
  card: {
    borderBottomLeftRadius: '2px',
    borderBottomRightRadius: '2px',
    mt: '2px',
  },
  cardOne: {
    width: '96%',
    height: 3,
  },
  cardTwo: {
    zIndex: 1,
    width: '93%',
    height: 3,
  },
} satisfies (Record<string, SxProps<Theme> | ((backgroundColor: string) => SxProps<Theme>)>);

export default styles;
